







































import {Vue, Component} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {PrijavaKvara} from "@/services/BackendProxies";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class PrijavaKvaraComponent extends mixins(ComponentBaseMixin) {

    prijavaKvara = PrijavaKvara.fromJS({datum: new Date()});

    async created() {
        this.$nextTick(() => {
            (<any>this.$refs.form).validate();
        });
    }

    async sacuvajPrijavuKvara() {
        const isValidForm = await (<any>this.$refs.form).validate();
        if (isValidForm) {
            this.prijavaKvara = await this.saveData(() => dataProxy.sacuvajPrijavuKvara(this.prijavaKvara))();
        }
    }

    novaPrijava() {
        this.prijavaKvara = PrijavaKvara.fromJS({datum: new Date()});
    }
}
